export default "__VITE_ASSET__ceb92c4a__"